const nielsenPeriodRegex = /^\d{4}P(0[1-9]|1[0-3])$/;
export function isAValidNielsenPeriod(value) {
    return nielsenPeriodRegex.test(value);
}
export function nielsenPeriodStrToNielsenPeriod(value) {
    if (!isAValidNielsenPeriod(value)) {
        throw new Error(`Invalid Nielsen period "${value}"`);
    }
    const parts = value.split('P');
    return {
        year: parts[0] ? parseInt(parts[0], 10) : NaN,
        period: parts[1] ? parseInt(parts[1], 10) : NaN
    };
}
export function nielsenPeriodToStr({ year, period }) {
    return `${year}P${period.toString().padStart(2, '0')}`;
}
export function formatNielsenPeriodToReadableStr(period) {
    return `P${period.period.toString().padStart(2, '0')} ${period.year}`;
}
export function nielsenPeriodToInt(period) {
    const year = parseInt(period.substring(0, 4));
    const month = parseInt(period.substring(5));
    // Check for valid year and month
    if (isNaN(year) || isNaN(month) || month <= 0 || month > 13) {
        return null; // Invalid period
    }
    return year * 100 + month;
}
export function intToNielsenPeriod(value) {
    const year = Math.floor(value / 100);
    const period = value % 100;
    if (period <= 0 || period > 13) {
        return null; // Invalid period value
    }
    return { year, period };
}
export function generateNielsenPeriods(minPeriod, maxPeriod) {
    const minInt = nielsenPeriodToInt(minPeriod);
    const maxInt = nielsenPeriodToInt(maxPeriod);
    const periods = [];
    if (minInt === null || maxInt === null) {
        console.error('Invalid input periods');
        return periods;
    }
    for (let i = minInt; i <= maxInt; i++) {
        const nielsenPeriod = intToNielsenPeriod(i);
        if (nielsenPeriod !== null) {
            periods.push(nielsenPeriod);
        }
    }
    return periods;
}
//# sourceMappingURL=period.utils.js.map